import React, { useEffect } from "react";
import { Modal, Form, Input, Button, notification } from "antd";
import { useMutation } from "@tanstack/react-query";
import { updateSpecSection } from "../services/specSectionsAPI";
import queryClient from "../queryClient";

const UpdateSpecSectionModal = ({ visible, onClose, specSection }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (specSection) {
      form.setFieldsValue({
        section_number: specSection.section_number,
        title: specSection.title,
      });
    }
  }, [specSection]);

  const mutation = useMutation({
    mutationFn: updateSpecSection,
    onSuccess: () => {
      queryClient.invalidateQueries("specSections");
      notification.success({ message: "Spec Section updated successfully" });
      onClose();
      form.resetFields();
    },
    onError: (error) => {
      notification.error({
        message: "Failed to update Spec Section",
        description: error.message,
      });
    },
  });

  const handleUpdateSpecSection = (values) => {
    const specSectionData = { ...values };
    mutation.mutate({ specSectionId: specSection.id, specSectionData });
  };

  return (
    <Modal
      title="Update Spec Section"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Form form={form} onFinish={handleUpdateSpecSection} layout="vertical">
        <Form.Item
          label="Section Number"
          name="section_number"
          rules={[
            { required: true, message: "Please input the section number!" },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Title"
          name="title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={mutation.isPending}>
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default UpdateSpecSectionModal;
